module.exports = __webpack_public_path__ + "img/public/SiteIcons/goSiteIcon.svg?f6067050";